import { AutogenModelZoneArea, AutogenRowZoneArea } from "./autogen/AutogenModelZoneArea";

export class ModelZoneArea extends AutogenModelZoneArea<RowZoneArea> {
	constructor() {
		super(RowZoneArea);
	}
}

export class RowZoneArea extends AutogenRowZoneArea {
}